import { jsxs as i, jsx as r } from "react/jsx-runtime";
const d = ({
  size: e = 24,
  color: t = "currentColor",
  titleAccess: o,
  ...s
}) => /* @__PURE__ */ i(
  "svg",
  {
    "aria-label": o,
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    ...s,
    children: [
      /* @__PURE__ */ r("path", { d: "M2.40039 4.80005H21.6004", stroke: t, strokeWidth: "1.5", strokeLinecap: "round" }),
      /* @__PURE__ */ r("path", { d: "M2.40039 12H21.6004", stroke: t, strokeWidth: "1.5", strokeLinecap: "round" }),
      /* @__PURE__ */ r("path", { d: "M2.40039 19.2H21.6004", stroke: t, strokeWidth: "1.5", strokeLinecap: "round" })
    ]
  }
);
export {
  d as BurgerNavIcon
};
